import { useIntl } from 'react-intl'
import StepperProgressSteps from 'LuxKit/Steppers/StepperProgressSteps'
import StepperProgressStep from 'LuxKit/Steppers/StepperProgressStep'
import config from 'constants/config'

interface Props {
  currentStep: 'login' | 'agentHubAccount' | 'commissionsPayout'
}

function AgentHubAccountSetupStepIndicator(props: Props) {
  const { currentStep } = props
  const intl = useIntl()

  const isCommissionsPayoutStepEnabled = config.AGENT_HUB_COLLECT_PAYOUT_DETAILS_ENABLED

  const getActiveStepIndex = () => {
    switch (currentStep) {
      case 'login':
        return 0
      case 'agentHubAccount':
        return 1
      case 'commissionsPayout':
        return 2
      default:
        return 0
    }
  }

  const createPasswordLabel = intl.formatMessage({
    id: 'U_Os8Q3W0c7dN09BeDJ7',
    defaultMessage: 'Create password',
    description: 'Step label for creating password during agent hub account setup',
  })

  const completeAgencyDetailsLabel = intl.formatMessage({
    id: 'uVBdJMLuEE6FaY0kT3If',
    defaultMessage: 'Complete agency details',
    description: 'Step label for completing agency details during agent hub account setup',
  })

  const setupCommissionsPayoutLabel = intl.formatMessage({
    id: '_3lvU8_V0hlTeM8R3IMs',
    defaultMessage: 'Set up commissions payout',
    description: 'Step label for setting up commissions payout during agent hub account setup',
  })

  const steps = [
    <StepperProgressStep
      key="login"
      stepIndex={0}
      label={createPasswordLabel}
    />,
    <StepperProgressStep
      key="agentHubAccount"
      stepIndex={1}
      label={completeAgencyDetailsLabel}
    />,
  ]

  if (isCommissionsPayoutStepEnabled) {
    steps.push(
      <StepperProgressStep
        key="commissionsPayout"
        stepIndex={2}
        label={setupCommissionsPayoutLabel}
      />,
    )
  }

  return (
    <StepperProgressSteps activeStepIndex={getActiveStepIndex()}>
      {steps}
    </StepperProgressSteps>
  )
}

export default AgentHubAccountSetupStepIndicator
